<!-- recogidas pendientes -->
<div *ngIf="usr.swRecogidas === '1'"
     class="accordion"
     id="accordion1">

    <div class="card">
        <div class="card-header"
             [ngClass]="{'bg-success': preparacionesList && preparacionesList.length > 0}"
             id="heading_1_1">
            <h2 class="mb-0">
                <button class="btn btn-link no-underline"
                        type="button"
                        data-toggle="collapse"
                        data-target="#collapse_1_1"
                        aria-expanded="false"
                        aria-controls="collapse_1_1">
                    <div class="row page-titles"
                         [ngClass]="{'bg-success': preparacionesList && preparacionesList.length > 0}">
                        <h3 class="text-themecolor"> <i class="text-secondary fa-solid fa-cart-flatbed"></i> {{preparacionesList.length| i18nPlural: recogidasPluralMap}} </h3>
                    </div>
                </button>
            </h2>
        </div>

        <div id="collapse_1_1"
             class="collapse"
             aria-labelledby="heading_1_1"
             data-parent="#accordion1"
             [hidden]="!preparacionesList || preparacionesList.length === 0">

            <div class="card-body">
                <div class="col-lg-12">
                    <div class="card">
                        <div *ngFor="let prep of preparacionesList">
                            <div class="card-body">
                                <a [routerLink]="'/pda/prepara_recoge/' + prep.recogida_cod"
                                   class="btn btn-info btn-block"
                                   [ngClass]="{'bg-warning': prep.campanyaTipo === '1 a 1'}">
                                    {{prep.recogida_cod}}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>







<!-- preparaciones pendientes -->
<div *ngIf="usr.swPreparaciones === '1'"
     class="accordion"
     id="accordion2">
    <div class="card">
        <div class="card-header"
             [ngClass]="{'bg-success': preparacionesList2 && preparacionesList2.length > 0}"
             id="heading_2_1">
            <h2 class="mb-0">
                <button class="btn btn-link no-underline"
                        type="button"
                        data-toggle="collapse"
                        data-target="#collapse_2_1"
                        aria-expanded="false"
                        aria-controls="collapse_2_1">
                    <div class="row page-titles"
                         [ngClass]="{'bg-success': preparacionesList2 && preparacionesList2.length > 0}">
                        <h3 class="text-themecolor"> <i class="text-secondary fa-solid fa-box-open"></i> {{preparacionesList2.length| i18nPlural: preparacionesPluralMap}} </h3>
                    </div>
                </button>
            </h2>
        </div>

        <div id="collapse_2_1"
             class="collapse"
             aria-labelledby="heading_2_1"
             data-parent="#accordion2"
             [hidden]="!preparacionesList2 || preparacionesList2.length === 0">

            <div class="card-body">
                <div class="col-lg-12">
                    <div class="card">
                        <div *ngFor="let prep of preparacionesList2">
                            <div class="card-body">
                                <a [routerLink]="'/pda/prepara_envio/' + prep.uic"
                                   class="btn btn-info btn-block"
                                   [ngClass]="{'bg-warning': prep.campanyaTipo === '1 a 1'}">
                                    {{prep.camp_cod}} {{prep.uic}}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>





<!-- entradas directas pendientes -->
<div *ngIf="usr.swEntradasDirectas === '1'"
     class="accordion"
     id="accordion3">
    <div class="card">
        <div class="card-header"
             [ngClass]="{'bg-success': entradasDirectasPdaList && entradasDirectasPdaList.length > 0}"
             id="heading_3_1">
            <h2 class="mb-0">
                <button class="btn btn-link no-underline"
                        type="button"
                        data-toggle="collapse"
                        data-target="#collapse_3_1"
                        aria-expanded="false"
                        aria-controls="collapse_3_1">
                    <div class="row page-titles"
                         [ngClass]="{'bg-success': entradasDirectasPdaList && entradasDirectasPdaList.length > 0}">
                        <h3 class="text-themecolor"> <i class="text-secondary fa-solid fa-truck-ramp-box"></i> {{entradasDirectasPdaList.length| i18nPlural: entradasDirectasPdaPluralMap}} </h3>
                    </div>
                </button>
            </h2>
        </div>

        <div id="collapse_3_1"
             class="collapse"
             aria-labelledby="heading_3_1"
             data-parent="#accordion3"
             [hidden]="!entradasDirectasPdaList || entradasDirectasPdaList.length === 0">

            <div class="card-body">
                <div class="col-lg-12">
                    <div class="card">
                        <div *ngFor="let prep of entradasDirectasPdaList">
                            <div class="card-body">
                                <a [routerLink]="'/pda/entrada_directa_detall/' + prep.id"
                                   class="btn btn-info btn-block">
                                    {{prep.cliNombre}} - {{prep.albaran}}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>





<!-- entradas editables desde PDA -->
<div *ngIf="usr.swEntradasPendientes === '1'"
     class="accordion"
     id="accordion4">
    <div class="card">
        <div class="card-header"
             [ngClass]="{'bg-success': entradasEditablePdaList && entradasEditablePdaList.length > 0}"
             id="heading_4_1">
            <h2 class="mb-0">
                <button class="btn btn-link no-underline"
                        type="button"
                        data-toggle="collapse"
                        data-target="#collapse_4_1"
                        aria-expanded="false"
                        aria-controls="collapse_4_1">
                    <div class="row page-titles"
                         [ngClass]="{'bg-success': entradasEditablePdaList && entradasEditablePdaList.length > 0}">
                        <h3 class="text-themecolor"> <i class="text-secondary fa-solid fa-truck"></i> {{entradasEditablePdaList.length| i18nPlural: entradasEditablePluralMap}} </h3>
                    </div>
                </button>
            </h2>
        </div>

        <div id="collapse_4_1"
             class="collapse"
             aria-labelledby="heading_4_1"
             data-parent="#accordion4"
             [hidden]="!entradasEditablePdaList || entradasEditablePdaList.length === 0">

            <div class="card-body">
                <div class="col-lg-12">
                    <div class="card">
                        <div *ngFor="let prep of entradasEditablePdaList">
                            <div class="card-body">
                                <a [routerLink]="'/pda/entrada_add/' + prep.id"
                                   class="btn btn-info btn-block">
                                    {{prep.cliNombre}} - {{prep.albaran}} ({{prep.pales}} palés)
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>









<!-- Entradas sin ubicar fisicamente -->
<div *ngIf="usr.swEntradasValidar === '1'"
     class="accordion"
     id="accordion5">
    <div class="card">
        <div class="card-header"
             [ngClass]="{'bg-success': entradasNoUbicadasList && entradasNoUbicadasList.length > 0}"
             id="heading_5_1">
            <h2 class="mb-0">
                <button class="btn btn-link no-underline"
                        type="button"
                        data-toggle="collapse"
                        data-target="#collapse_5_1"
                        aria-expanded="false"
                        aria-controls="collapse_5_1">
                    <div class="row page-titles"
                         [ngClass]="{'bg-success': entradasNoUbicadasList && entradasNoUbicadasList.length > 0}">
                        <h3 class="text-themecolor"> <i class="text-secondary fa-solid fa-circle-check"></i> {{entradasNoUbicadasList.length| i18nPlural: entradasPluralMap}} </h3>
                    </div>
                </button>
            </h2>
        </div>

        <div id="collapse_5_1"
             class="collapse"
             aria-labelledby="heading_5_1"
             data-parent="#accordion5"
             [hidden]="!entradasNoUbicadasList || entradasNoUbicadasList.length === 0">

            <div class="card-body">
                <div class="col-lg-12">
                    <div class="card">
                        <div *ngFor="let entrada of entradasNoUbicadasList">
                            <div class="card-body">
                                <a [routerLink]="'/pda/entrada_articulos/' + entrada.id"
                                   class="btn btn-info btn-block">
                                    <span class="fs-10">{{entrada.ubiPlaya | mask: '00.00.00.00.00.00'}}</span> - {{entrada.cliNombre}} - {{entrada.albaran}}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>




<!-- Campañas sin embalaje -->
<div *ngIf="usr.swEmbalajes === '1'"
     class="accordion"
     id="accordion6">
    <div class="card">
        <div class="card-header"
             [ngClass]="{'bg-success': campanyasSinEmbalarList && campanyasSinEmbalarList.length > 0}"
             id="heading_6_1">
            <h2 class="mb-0">
                <button class="btn btn-link no-underline"
                        type="button"
                        data-toggle="collapse"
                        data-target="#collapse_6_1"
                        aria-expanded="false"
                        aria-controls="collapse_6_1">
                    <div class="row page-titles"
                         [ngClass]="{'bg-success': campanyasSinEmbalarList && campanyasSinEmbalarList.length > 0}">
                        <h3 class="text-themecolor"> <i class="text-secondary fa-solid fa-boxes-packing"></i> {{campanyasSinEmbalarList.length| i18nPlural: campanyasPluralMap}} </h3>
                    </div>
                </button>
            </h2>
        </div>

        <div id="collapse_6_1"
             class="collapse"
             aria-labelledby="heading_6_1"
             data-parent="#accordion6"
             [hidden]="!campanyasSinEmbalarList || campanyasSinEmbalarList.length === 0">

            <div class="card-body">
                <div class="col-lg-12">
                    <div class="card">
                        <div *ngFor="let campanya of campanyasSinEmbalarList">
                            <div class="card-body">
                                <a [routerLink]="'/pda/pedidos_list_pack/' + campanya.id"
                                   class="btn btn-info btn-block"
                                   [ngClass]="{'bg-warning': campanya.campanyaTipo === '1 a 1'}">
                                    {{campanya.camp_cod}}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>